export default __webpack_public_path__ + "static/media/f.a79174a1.mp4";